"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../../../utilities/ServiceFetch"));
/**
 * This class handles adding items to the China cart.
 */
var ChinaCartService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     */
    function ChinaCartService(options) {
        this.endpoint = options.endpoint;
    }
    /**
     * Adds items to shopping cart in IRW.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.token Token.
     * @returns Promise object.
     */
    ChinaCartService.prototype.addToCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cartCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint + "/add-products", {
                            method: 'post',
                            credentials: 'same-origin',
                            headers: this.getHeaders(options.token),
                            body: this.getAddToCartBody(options.items)
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getCartCount(options)];
                    case 2:
                        cartCount = _a.sent();
                        return [2 /*return*/, {
                                cartCount: cartCount,
                                errorList: []
                            }];
                }
            });
        });
    };
    /**
     * Returns cart count for a shopping cart.
     *
     * @param options Options.
     * @param options.token Token.
     * @returns Promise object.
     */
    ChinaCartService.prototype.getCartCount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, quantity, _i, _a, item;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            method: 'get',
                            credentials: 'same-origin',
                            headers: this.getHeaders(options.token)
                        })];
                    case 1:
                        response = _b.sent();
                        quantity = 0;
                        for (_i = 0, _a = response['items']; _i < _a.length; _i++) {
                            item = _a[_i];
                            quantity += item.quantity;
                        }
                        return [2 /*return*/, quantity];
                }
            });
        });
    };
    /**
     * Returns the body.
     *
     * @param items Items.
     * @returns Add to cart body.
     */
    ChinaCartService.prototype.getAddToCartBody = function (items) {
        return JSON.stringify({
            products: items.map(function (item) { return ({
                productFullId: (item.type.toUpperCase() === 'SPR' ? 's' : '') + item.id,
                quantity: item.quantity
            }); })
        });
    };
    /**
     * Returns headers.
     *
     * @param token Token.
     * @returns Headers.
     */
    ChinaCartService.prototype.getHeaders = function (token) {
        return {
            'content-type': 'application/json',
            'x-client-channel': 'WEB',
            'x-client-platform': 'PcWeb',
            authorization: "Bearer " + token
        };
    };
    return ChinaCartService;
}());
exports.default = ChinaCartService;
//# sourceMappingURL=ChinaCartService.js.map